import { FC, LabelHTMLAttributes } from 'react';
import classNames from 'classnames';
import './TransactionsDateFilterDialogLabel.scss';

export const TransactionsDateFilterDialogLabel: FC<LabelHTMLAttributes<HTMLLabelElement>> = ({
  className,
  children,
  ...attrs
}) => {
  return (
    <label className={classNames('TransactionsDateFilterDialogLabel', className)} {...attrs}>
      {children}
    </label>
  );
};
